import { createSlice } from '@reduxjs/toolkit';

// types
import { SectionSliceProps } from 'types/section';

const initialState: SectionSliceProps = {
    sectionName: '',
    sectionComponent: undefined
};

// ==============================|| SLICE - SECTION ||============================== //

const section = createSlice({
    name: 'section',
    initialState,
    reducers: {
        updateSectionName(state, action) {
            const { sectionName } = action.payload;

            state.sectionName = sectionName;
        },
        updateSectionComponent(state, action) {
            state.sectionComponent = action.payload;
        }
    }
});

export default section.reducer;

export const { updateSectionName, updateSectionComponent } = section.actions;
